module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0050.jpg?v=3d23bbf9";